var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SelectionList, Text, TextWithHighlight, } from '@dixa/lib-shared-habla';
import classNames from 'classnames';
import { memo } from 'react';
import styles from './analyticsFilterItem.module.scss';
const AnalyticsFilterItem = (_a) => {
    var { className, contentClassName, children, value, label, highlight, color, isDisabled = false } = _a, selectionListItemProps = __rest(_a, ["className", "contentClassName", "children", "value", "label", "highlight", "color", "isDisabled"]);
    return (_jsxs(SelectionList.Item, Object.assign({ className: classNames(styles.root, className), contentClassName: classNames(styles.content, contentClassName), value: value, isDisabled: isDisabled }, selectionListItemProps, { children: [color && (_jsx("div", { className: styles.colorIndicator, style: {
                    backgroundColor: color,
                } })), _jsx(Text.Paragraph, { children: _jsx(TextWithHighlight, { text: label, highlight: highlight }) }), children] })));
};
const _AnalyticsFilterItem = memo(AnalyticsFilterItem);
export { _AnalyticsFilterItem as AnalyticsFilterItem };
